module.exports = __webpack_public_path__ + "static/img/about01-en.d5be1c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about01-en.png
// module id = g8tI
// module chunks = 1